/*
    Блокировка скролла
*/

let scrollPosition = 0;

App.lockScroll = {
    lock: () => {
        /**
         * Так как страница перепрыгивает вверх,
         * когда срабатывает overflow:hidden,
         * принудительно сколлим её до
         * запомненного состояния
         */
        scrollPosition = App.W.scrollTop();

        $('html, body').addClass('_noscroll').scrollTop(scrollPosition);
    },
    unlock: () => $('html, body').removeClass('_noscroll').scrollTop(scrollPosition)
};
